import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError, map, timeout } from 'rxjs/operators';
import { Activity, ProjectActivity, ProjectMaterial, ProjectVm, KeyDatesDto, ReviewComments, StoreValidationVM, StoreValidationRequestVM, ReviewLog } from '../models/project-vm';
import { LocationDto, ProjectApproval, SalesPlanVm } from '../models/salesplan-vm';
import { Material } from '../models/Material';
import { RefTypeEnum } from '../enums/ref-type-enum';
import { ProjectsAndSalesPlanData } from '../../Dashboard/model/project.salesplan.data';
import { ErrorLoggerService } from '../../shared/services/error-logger.service';
import { StoreCoverage } from '../models/storecoverage';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  instructions = new BehaviorSubject<any>(null);
  constructor(private httpClient: HttpClient, private errorLogService: ErrorLoggerService
  ) { }

  getSREUsers(vendorId: any): Observable<any> {
    const url = `${environment.gateway_url}/getsreusers/${vendorId}`;
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  getDisplayType(): Observable<any> {
    const url = `${environment.gateway_url}/getdisplaytypes`;
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  addEditProjectDetails(projectDetails: ProjectVm): Observable<any> {
    const url = `${environment.gateway_url}/addeditprojectdetails`;

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');

    return this.httpClient.post(url, projectDetails).pipe(
      map(item => {
        return item;
      })
    );
  }

  getLookups(): Observable<any> {
    return this.httpClient.get<any>(environment.gateway_url + '/GetAllLookups');
  }

  // Observable stream for components to subscribe to
  // Method to update the data
  updateInstructions(data: any): void {
    this.instructions.next(data);
  }

  addEditSalesplanDetails_old(salesplanDetails: SalesPlanVm): Observable<any> {
    const url = `${environment.gateway_url}/addeditsalesplandetails`;
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');


    return this.httpClient.post(url, salesplanDetails, { headers }).pipe(
      map(item => {
        return item;
      })
    );
  }

  addEditSalesplanDetails(salesplanDetails: SalesPlanVm): Observable<any> {
    const url = `${environment.gateway_url}/addeditsalesplandetails`;
    return this.httpClient.post(url, salesplanDetails).pipe(
      map(item => item)
    );
  }


  createOrUpdateProjectApproval(projectApprovalObj: ProjectApproval): Observable<any> {
    const url = `${environment.gateway_url}/createorupdateprojectapproval`;
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');

    return this.httpClient.post(url, projectApprovalObj, { headers }).pipe(
      map(item => {
        return item;
      })
    );
  }

  getProjectDetails(headerid: number): Observable<any> {
    const url = `${environment.gateway_url}/getprojectdetailsbyheaderid/${headerid}`;

    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  getObjectMaterialActivityAttachmentsData(headerid: number): Observable<any> {

    const url = `${environment.gateway_url}/GetObjectMaterialActivityAttachmentsData/${headerid}`;

    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  getSalesplanDetails(salesplanId: number): Observable<any> {
    const url = `${environment.gateway_url}/getsalesplandetailsbyid/${salesplanId}`;

    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  downloadStorelList(vendorId: any): Observable<any> {
    const url = `${environment.gateway_url}/downlaodstorelist/${vendorId}`;
    return this.httpClient.get(url, {
      responseType: 'blob', // Important: responseType must be blob to handle binary data
      observe: 'response'   // Required to access the full HttpResponse, including headers
    }).pipe(
      map((res: HttpResponse<Blob>) => {


        // Create a Blob from the response
        const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
      })
    );
  }

  downloadProductlList(categoryId: any): Observable<any> {
    const url = `${environment.gateway_url}/DownlaodProductsList/${categoryId}`
    return this.httpClient.get(url, {
      responseType: 'blob', // Important: responseType must be blob to handle binary data
      observe: 'response'   // Required to access the full HttpResponse, including headers
    }).pipe(
      map((res: HttpResponse<Blob>) => {


        // Create a Blob from the response
        const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
      })
    );
  }

  getAllProductsByCategory(categoryId: any): Observable<any> {
    const url = `${environment.gateway_url}/GetAllProductsByCategory/${categoryId}`
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  downloadStorelList1(vendorId: any): Observable<any> {
    const url = `${environment.gateway_url}/DownlaodStoreList1/${vendorId}`
    return this.httpClient.get(url, {
      responseType: 'blob', // Important: responseType must be blob to handle binary data
      observe: 'response'   // Required to access the full HttpResponse, including headers
    }).pipe(
      map((res: HttpResponse<Blob>) => {
        // if (!res.body) {
        //   throw new Error('Failed to download Excel file.'); // Handle empty response body
        // }

        if (res.status != 200) {
          //throw new Error('Failed to download Excel file.'); // Handle empty response body
          //console.log('No data found for the given ID');
        }
        else {
          // Parse content-disposition header to extract filename
          let filename = '';
          const contentDisposition = res.headers.get('content-disposition');
          if (contentDisposition) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '');
            }
          }

          // Create a Blob from the response
          const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

          // Create a download link and trigger it
          const downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = filename || 'storelist.xlsx';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }

      })
    );
  }
  getAllActivities(): Observable<Activity[]> {
    const url = `${environment.gateway_url}/getAllActivities`;

    return this.httpClient.get<any[]>(url).pipe(
      map((items: any[]) => {

        // Assuming your API response is an array of items, and you need to map them to ProjectActivity[]
        return items.map(item => this.mapToActivity(item));
      })
    );
  }

  private mapToActivity(item: any): Activity {
    // Implement your mapping logic here to map 'item' to ProjectActivity
    return {
      name: item.name,
      isChecked: item.isChecked,
      activityID: item.activityID
      // Add other properties as needed
    };
  }


  getAllMaterials(): Observable<Material[]> {
    const url = `${environment.gateway_url}/GetAllMaterials`;

    return this.httpClient.get<any[]>(url).pipe(
      map((items: any[]) => {
        return items.map(item => this.mapToMaterial(item));
      })
    );
  }

  private mapToMaterial(item: any): Material {
    // Implement your mapping logic here to map 'item' to ProjectActivity
    return {
      materialID: item.materialID,
      materialName: item.materialName,
      materialType: item.materialType,
      isActive: item.materialID
      // Add other properties as needed
    };
  }


  getThirdPartyAgencies(categoryId: any): Observable<any> {
    const url = `${environment.gateway_url}/GetThirdPartyAgencies/${categoryId}`
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  downloadShopCommWordDocument(agencyId: any): Observable<string> {
    const url = `${environment.gateway_url}/GetShopCOMMWordDocument/${agencyId}`;

    return this.httpClient.get<any>(url).pipe(
      map((downloadShoppCommWordData: string) => {
        return downloadShoppCommWordData;
      })
    );
  }

  saveUpdateApprovalFromProject(projectDetails: ProjectVm): Observable<any> {
    const url = `${environment.gateway_url}/SaveUpdateApproval`;

    return this.httpClient.post(url, projectDetails).pipe(
      map(item => {
        return item;
      })
    );
  }

  //Delete Images by SalesPlanId, ImageId and Imagetype
  deleteSalesPlanImages(salesPlanId?: number, imageId?: number, imageType?: string): Observable<any> {
    const url = `${environment.gateway_url}/deletesalesplanimages/${salesPlanId}/${imageId}/${imageType}`;
    return this.httpClient.delete(url).pipe(
      map(item => item ? item : [])
    );
  }

  saveUpdateApprovalFromSalesPlan(salesPlanDetails: SalesPlanVm): Observable<any> {
    const url = `${environment.gateway_url}/saveupdateapproval`;

    return this.httpClient.post(url, salesPlanDetails).pipe(
      map(item => {
        return item;
      })
    );
  }

  saveUpdateReviewApproval(commonApprovalDetails: any, refType: RefTypeEnum): Observable<any> {
    let url = '';

    if (refType == RefTypeEnum.Project) {
      url = `${environment.gateway_url}/SaveUpdateApproval`;
    }
    else if (refType == RefTypeEnum.Sales) {
      url = `${environment.gateway_url}/saveupdateapproval`;
    }

    return this.httpClient.post(url, commonApprovalDetails).pipe(
      map(item => {
        return item;
      })
    );
  }

  SaveUpdateExecutionProcess(modelDetails: any): Observable<any> {
    const url = `${environment.gateway_url}/SaveUpdateExecutionProcess`;

    return this.httpClient.post(url, modelDetails).pipe(
      map(item => {
        return item;
      })
    );
  }


  GetManageProjectsData(manageDto: object): Observable<any> {
    const url = `${environment.gateway_url}/getmanageprojectsdata`;
    return this.httpClient.post<ProjectsAndSalesPlanData>(url, manageDto).pipe(
      map(item => {
        return item;
      })
    );
  }

  getCategoryAgenciesByCategory(categoryId: any): Observable<any> {
    const url = `${environment.gateway_url}/GetCategoryAgenciesByCategory/${categoryId}`
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  getCategoryAgenciesByCategoryies(categories: number[]): Observable<any> {
    const url = `${environment.gateway_url}/GetCategoryAgenciesByCategoryies`
    return this.httpClient.post(url, categories).pipe(
      map(item => {
        return item;
      })
    );
  }

  downloadProductsByCategories(categories: number[]): Observable<any> {
    const url = `${environment.gateway_url}/DownloadProductsListByCategories`
    return this.httpClient.post(url, categories, {
      responseType: 'blob', // Important: responseType must be blob to handle binary data
      observe: 'response'   // Required to access the full HttpResponse, including headers
    }).pipe(
      map((res: HttpResponse<Blob>) => {


        // Create a Blob from the response
        const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
      })
    );
  }

  UpdateKeyDates(keyDates: KeyDatesDto): Observable<any> {
    const url = `${environment.gateway_url}/updatekeydates`;
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');


    return this.httpClient.post(url, keyDates, { headers }).pipe(
      map(item => {
        return item;
      })
    );
  }

  addComments(reviewComment: ReviewComments): Observable<any> {
    const url = `${environment.gateway_url}/addreviewcomment`;
    return this.httpClient.post(url, reviewComment).pipe(
      map(item => {
        return item;
      })
    );
  }


  getReviewLogs(refid: number, type: string): Observable<any> {
    const url = `${environment.gateway_url}/getreviewcommentslist/${refid}/${type}`
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  validateStoreNumbers(inputVM: StoreValidationRequestVM): Observable<any> {
    const url = `${environment.gateway_url}/validatetorenumbers`
    return this.httpClient.post<StoreValidationVM>(url, inputVM).pipe(
      map(item => {
        return item;
      })
    );
  }

  getPRoductFlows(): Observable<any> {
    const url = `${environment.gateway_url}/getproductflows`;

    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }
  deleteProductByCategory(refId: number, refType: string, categoryId: number): Observable<any> {
    const url = `${environment.gateway_url}/deleteinstallationproductbycategory/${refId}/${refType}/${categoryId}`
    return this.httpClient.delete(url);
  }
  // deleteProject(refId: number, refType: string): Observable<any> {
  //   const url = `${environment.gateway_url}/deleteproject/${refId}/${refType}`
  //   return this.httpClient.post(url, {});
  // }

  deleteProjects(refIds: number | number[], refType: string): Observable<any> {
    const isMultiple = Array.isArray(refIds);

    if (isMultiple) {
      const url = `${environment.gateway_url}/deletemultipleprojects/${refType}`;
      return this.httpClient.post(url, refIds); // refIds in body
    } else {
      const url = `${environment.gateway_url}/deleteproject/${refIds}/${refType}`;
      return this.httpClient.post(url, {});
    }
  }

  addItemReviewLogs(reviewLog: ReviewLog): Observable<any> {
    const url = `${environment.gateway_url}/addreviewlog`;
    return this.httpClient.post(url, reviewLog).pipe(
      map(item => {
        return item;
      })
    );
  }
  getLocations(): Observable<any> {
    const url = `${environment.gateway_url}/getlocations`;
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }
  getChildByParent(parentId: number): Observable<any> {
    const url = `${environment.gateway_url}/getchildbyparent/${parentId}`;
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  getAllLogos(): Observable<any> {
    const url = `${environment.gateway_url}/getlogoimages`;
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  addAdhocQuestions(adhocData: any): Observable<any> {
    const url = `${environment.gateway_url}/AddUpdateAdHocRequest`;
    return this.httpClient.post<any>(url, adhocData)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  patchAdhocData(adhocId: any): Observable<any> {
    const url = `${environment.gateway_url}/getadHocRequestbyid/${adhocId}`;
    return this.httpClient.get<any>(url)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError1(error))
      );
  }

  AdhocList(adhocData?: any, title?: any, startDate1?: any, startDate2?: any, categoryIdCategoryDropdown?: any): Observable<any> {
    const url = `${environment.gateway_url}/getadhoclist`;
    let body: any = {};

    if (adhocData) {
      body['categoryIds'] = adhocData;
    }

    if (title) {
      body['title'] = title;
    }

    if (startDate1) {
      body['FromDate'] = startDate1;
    }

    if (startDate2) {
      body['ToDate'] = startDate2;
    }

    if (categoryIdCategoryDropdown) {
      body['categoryIds'] = categoryIdCategoryDropdown;
    }

    return this.httpClient.post<any>(url, body).pipe(
      catchError((error: HttpErrorResponse) => this.handleError1(error))
    );
  }

  GetAdHocReport(adHocRequestId: number): Observable<any> {
    const url = `${environment.gateway_url}/getadhocrequestreport/${adHocRequestId}`;

    return this.httpClient.post(url, {}, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      timeout(120000), // 120 seconds
      map((res: HttpResponse<Blob>) => {
        // Create a Blob from the response
        const blob = new Blob([res.body!], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        return blob;
      })
    );
  }

  private handleError1(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      //this.msgService.htmlError('A client-side error occurred. Please try again.');
      this.errorLogService.logErrorNew('Client Side Error', error);
    } else {
      // Server-side error
      if (error.status === 0) {
        //this.msgService.htmlSuccess('The API is currently unreachable. Please try again later.');
        this.errorLogService.logErrorNew('API Not running', error);
      } else {
        //this.msgService.htmlSuccess(`API returned an error: ${error.status} - ${error.message}`);
        this.errorLogService.logErrorNew('API Error', error);
      }
    }

    return throwError('Something went wrong; please try again later.');
  }

  saveLocation(locationDetails: LocationDto): Observable<any> {
    const url = `${environment.gateway_url}/savelocation`;

    return this.httpClient.post(url, locationDetails).pipe(
      map(item => {
        return item;
      })
    );
  }

  getStoresByStates(vendorId: number, stateCodes: string[]): Observable<any> {
    const url = `${environment.gateway_url}/getstoresbystatecodes/${vendorId}`
    return this.httpClient.post(url, stateCodes).pipe(
      map(item => {
        return item;
      })
    );
  }

  saveStoreCoverage(coveragePlanDetails: StoreCoverage): Observable<any> {
    const url = `${environment.gateway_url}/savestorecoverage`;

    return this.httpClient.post(url, coveragePlanDetails).pipe(
      map(item => {
        return item;
      })
    );
  }

  getAllStoreCoverageData(): Observable<any> {
    const url = `${environment.gateway_url}/getallstorecoverage`;
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  getStoreCoverageData(storeCoverageId: number): Observable<any> {
    const url = `${environment.gateway_url}/getstorecoverage/${storeCoverageId}`;
    return this.httpClient.get(url).pipe(
      map(item => {
        return item;
      })
    );
  }

  //Download Store Coverage Report File
  DownloadStoreCoverageReportDocument(storeCoverageId: any, fileName: any): Observable<any> {
    const url = `${environment.gateway_url}/downloadstorecoveragereportdocument/${storeCoverageId}/${fileName}`
    return this.httpClient.get(url, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      map((res: HttpResponse<Blob>) => {
        // Create a Blob from the response
        const blob = new Blob([res.body!], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
      })
    );
  }

  //Update Store Coverage Status
  UpdateStoreCoverageStatus(storeCoverageData: StoreCoverage): Observable<any> {
    const url = `${environment.gateway_url}/updatestorecoveragestatus`
    return this.httpClient.put(url, storeCoverageData).pipe(
      map(item => item ? item : [])
    );
  }

}
